<nav class="navbar navbar-expand-lg navbar-dark bg-primary">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/">ClouDings</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item" routerLink="/home" routerLinkActive="active" data-toggle="collapse"
          data-target="#navbarNav">
          <a class="nav-link">Home</a>
        </li>
        <li class="nav-item" routerLink="/watchparty" routerLinkActive="active" data-toggle="collapse"
          data-target="#navbarNav">
          <a class="nav-link">WatchParty</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
